const setting = {
  namespaced: true,
  state: {
    language: process.env.VUE_APP_LANG, // .envから引き継ぎ
    bikkurapon: true, // 初回の場合はtrue
    isForceQuit: false, // 強制終了かどうか
    isSideMenuOpen: false,
    childrenQr: '', // base64のQR画像
  },
  getters: {
    getLanguage: (state) => {
      return state.language
    },
    getBikkurapon: (state) => {
      return state.bikkurapon
    },
    getIsForceQuit: (state) => {
      return state.isForceQuit
    },
    getIsSideMenuOpen: (state) => {
      return state.isSideMenuOpen
    },
    getChildrenQr: (state) => {
      return state.childrenQr
    },
  },
  actions: {
    setLanguage: ({ commit }, payload) => {
      commit('setLanguage', payload)
    },
    setBikkurapon: ({ commit }, payload) => {
      commit('setBikkurapon', payload)
    },
    setIsForceQuit: ({ commit }, payload) => {
      commit('setIsForceQuit', payload)
    },
    setIsSideMenuOpen: ({ commit }, payload) => {
      commit('setIsSideMenuOpen', payload)
    },
    setChildrenQr: ({ commit }, payload) => {
      commit('setChildrenQr', payload)
    },
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language
    },
    setBikkurapon(state, bikkurapon) {
      state.bikkurapon = bikkurapon
    },
    setIsForceQuit: (state, payload) => {
      state.isForceQuit = payload
    },
    setIsSideMenuOpen: (state, payload) => {
      state.isSideMenuOpen = payload
    },
    setChildrenQr: (state, payload) => {
      state.childrenQr = payload
    },
  },
}

export default setting
